module.exports = __webpack_public_path__ + "static/media/NodataPPCView.da596056.png";